import React, { useEffect, useState } from "react";
import AdminSideMenu from "../../navbar/AdminSideMenu";
import AdminTopMenu from "../../navbar/AdminTopMenu";
import { getCountryPrice, getMasterCountryList } from "../../../api/api";

const CountryPricing = () => {
  const [countryList, setCountryList] = useState([]);
  const [priceData, setPriceData] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const getCountryList = () => {
    getMasterCountryList().then((res) => {
      if (res.data.success === true) {
        setCountryList(res.data.data);
      } else {
        setCountryList([]);
      }
    });
  };

  useEffect(() => {
    getCountryList();
  }, []);

  const searchHandler = () => {
    if (!selectedCountry) {
      setPriceData(null);
      return;
    }
    setIsLoading(true);
    getCountryPrice(selectedCountry).then((res) => {
      setIsLoading(false);
      if (res.data.success === true) {
        setPriceData(res.data.message);
      } else {
        setPriceData([]);
      }
    });
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <AdminSideMenu />

        <div className="layout-page">
          <AdminTopMenu />

          <div className="content-wrapper">
            <div className="container-xxl container-p-y">
              <div className="">
                <div className="d-flex justify-content-between align-items-center">
                  <h5 className="card-header pl-0">Country Pricing</h5>
                  <div className="d-flex align-items-center gap-2">
                    <select
                      value={selectedCountry}
                      onChange={(e) => setSelectedCountry(e.target.value)}
                      className="form-select"
                    >
                      <option value="">Select Country</option>
                      {countryList.map((items, i) => (
                        <option key={i} value={items.country_code}>
                          {items.country_name} ( {items.country_code})
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={searchHandler}
                      disabled={isLoading}
                    >
                      {isLoading ? "Searching..." : "Search"}
                    </button>
                  </div>
                </div>
                <div className="card">
                  <div
                    style={{ minHeight: "200px" }}
                    className="table-responsive text-nowrap"
                  >
                    {priceData && (
                      <table className="table">
                        <thead>
                          <tr>
                            <th>Country</th>
                            <th>Route Name</th>
                            <th>Vendor</th>
                            <th>Buy Price</th>
                            <th>Status</th>
                            <th>Created</th>
                          </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                          {priceData.length > 0 ? (
                            priceData.map((items, i) => (
                              <tr key={i}>
                                <td>
                                  <span className="text-primary">
                                    {items.country_name} ({items.country_code}
                                    )
                                  </span>
                                </td>
                                <td>{items.route_name}</td>
                                <td>{items.vendor_name}</td>
                                <td>{items.buy_price}</td>
                                <td>
                                  {items.status === 1 ? (
                                    <span className="badge bg-label-success me-1">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge bg-label-danger me-1">
                                      Inactive
                                    </span>
                                  )}
                                </td>
                                <td>{items.created}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Price Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountryPricing;
